var exports = {
  "Pg": "ProfileCardLayout.module__previewLabel___QzJDNl",
  "lV": "ProfileCardLayout.module__cardWrap___QzJDNl",
  "Kq": "ProfileCardLayout.module__profileCard___QzJDNl",
};

module.exports = exports;
